import { CallRepository } from '@/features/chamados/domain/Call'
import { CallEvidenceImageRepository } from '@/features/chamados/domain/CallEvidenceImage'
import { CallProduct_Repository } from '@/features/chamados/domain/CallProduct'
import { CallTechRepository } from '@/features/chamados/domain/CallTech'
import { CallTechAttachment_Repository } from '@/features/chamados/domain/CallTechAttachment'
import { ContractRenovationRepository } from '@/features/contratos/domain/ContractRenovation'
import { TodoRepository } from '@/features/dashboard/domain/Todo'
import { EquipmentRepository } from '@/features/equipamentos/domain/Equipment'
import { VistaRepository } from '@/features/equipamentos/domain/Vista'
import { VistaProductRepository } from '@/features/equipamentos/domain/VistaProduct'
import { AssetRepository } from '@/features/patrimonios/services/Asset'
import { AssetLinkRepository } from '@/features/patrimonios/services/AssetLink'
import { AuthExternalRepository } from '@/features/sessao/domain/AuthExternalRepository'
import { AuthRepository } from '@/features/sessao/domain/AuthRepository'
import { UserRepository } from '@/features/usuarios/domain/User'
import { UserAbilitiesRepository } from '@/features/usuarios/domain/UserAbilities'

// prettier-ignore
export const Repository = {
  Core: {
    Auth:               AuthRepository,
    AuthExternal:       AuthExternalRepository,
    UserAbilities:      UserAbilitiesRepository,
    Todos:              TodoRepository,
  },
  Entity: {
    Asset:                   AssetRepository,
    AssetLink:               AssetLinkRepository,
    Call:                    CallRepository,
    CallTech:                CallTechRepository,
    CallEvidenceImage:       CallEvidenceImageRepository,
    CallTechAttachment:      CallTechAttachment_Repository,
    CallProduct:             CallProduct_Repository,
    ContractRenovation:      ContractRenovationRepository,
    Equipment:               EquipmentRepository,
    User:                    UserRepository,
    Vista:                   VistaRepository,
    VistaProduct:            VistaProductRepository,
  },
};
